import { FC } from 'react';
import styled from 'styled-components';

import ScrollPhoneSlides from './ScrollPhoneSlides';

const MobileSlider: FC<any> = ({
	slides,
	phoneRef,
	activeSlide,
	PhoneSlider,
	onHeadingClick,
}) => (
	<SliderWrapper>
		<PhoneSliderWrapper>
			<PhoneSlider mobile activeSlide={activeSlide} phoneRef={phoneRef} />
		</PhoneSliderWrapper>

		<ScrollSlidesWrapper>
			<ScrollPhoneSlides
				slides={slides}
				activeSlide={activeSlide}
				onHeadingClick={onHeadingClick}
			/>
		</ScrollSlidesWrapper>
	</SliderWrapper>
);

const SliderWrapper = styled.div`
	width: 100%;
	position: relative;
`;

const PhoneSliderWrapper = styled.div`
	display: flex;
	justify-content: center;
	background: transparent;

	@media (max-width: 799px) {
		margin-bottom: 20px;
		padding-top: 40px;
		position: sticky;
		top: 38px;
		z-index: 2;

		&:after {
			content: '';
			display: block;
			position: absolute;
			width: 100%;
			height: 100px;
			bottom: -56px;
			background: linear-gradient(
				180deg,
				var(--color-white) 0%,
				rgba(255, 255, 255, 0) 100%
			);
			pointer-events: none;
			z-index: -1;
		}

		&:before {
			content: '';
			display: block;
			background-color: var(--color-white);
			width: 100%;
			height: 80%;
			position: absolute;
			top: 26px;
		}
	}
`;

const ScrollSlidesWrapper = styled.div`
	border-top: 1px solid var(--color-white-40);
`;

export default MobileSlider;
